export default function getAuthHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    companyDocumentNumber: localStorage.getItem("companyDocumentNumber"),
    companyName: localStorage.getItem("companyName"),
  };
}
